/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-hero-banner',
  templateUrl: './hero-banner.component.html',
  styleUrl: './hero-banner.component.scss'
})
export class HeroBannerComponent {
  private _heroImages: any[] = [];
  private _overlayImages: any[] = [];
  private _overlayText: string = '';
  private _ourstory: string = '';

  @Input()
  set heroImages(value: any[]) {
    this._heroImages = value;
  }
  get heroImages(): any[] {
    return this._heroImages;
  }

  @Input()
  set overlayImages(value: any[]) {
    this._overlayImages = value;
  }
  get overlayImages(): any[] {
    return this._overlayImages;
  }

  @Input()
  set overlayText(value: string) {
    this._overlayText = value;
  }
  get overlayText(): string {
    return this._overlayText;
  }

  @Input()
  set ourstory(value: string) {
    this._ourstory = value;
  }
  get ourstory(): string {
    return this._ourstory;
  }

}
